export const PATHS = {
	LOGIN_PAGE: `/login`,
	AUTH_CODE_PAGE: `/auth/code`,
	AUTH_PAGE: `/auth`,
	HOME_PAGE: `/`,
	SIGN_IN_PAGE: `/sign-in`,
	DASHBOARD_PAGE: `/dashboard`,
	GENERAL_SETTINGS_PAGE: `/general-settings`,
	CONTRACT_PAGE: `/contract`,
	ORDERS_PAGE: `/orders`,
	ORDER_PAGE: `/order/:orderId`,
	// CONFIRMED_ORDERS_PAGE: `/orders/confirmed`,
	// ORDERS_FULFILLMENT_PAGE: `/orders/fulfillment`,
	// ORDERS_RETURNS_PAGE: `/orders/returns`,
	// ORDER_DISCOUNTS_PAGE: `/orders/discounts`,
	INVOICES_PAGE: `/invoices`,
	SALES_REPORTS_PAGE: `/sales-reports/:typeOfReport`,
	VAT_REPORTS_PAGE: '/vat-reports/:typeOfReport',
	VAT_CORRECTIONS_PAGE: `/vat-corrections`,
	NOTIFICATION_SETTINGS_PAGE: `/notification-settings`,
	PAYMENT_METHODS_PAGE: '/payment-methods',
	SECURITY_SETTINGS_PAGE: `/security-settings`,
	PRICING_PAGE: `/pricing`,
	INTEGRATIONS_PAGE: `/integrations`,
	SHIPMENTS_PAGE: `/shipments`,
	SHIPMENT_PAGE: `/shipment/:orderId`,
	HMRC_AUTH_REDIRECT: `/hmrc-auth-redirect`,
	GPSR_SERVICE_PAGE: `/gpsr-service`,
	GPSR_SERVICE_SKU_PAGE: `/gpsr-service/:productTypeId`,
	PRODUCT_TYPE_PAGE: `/product-type/:productTypeId`,
};

export const ORDERS_PATHS = {
	CONFIRMED_ORDERS_PAGE: `confirmed`,
	ORDERS_FULFILLMENT_PAGE: `fulfillment`,
	ORDERS_RETURNS_PAGE: `returns`,
	ORDER_DISCOUNTS_PAGE: `discounts`,
};
